export default __webpack_public_path__ + "static/Entenda0112-0f520e705f3a424a040f8a7a61440900.jpg";